<div class="header">
  <div class="title">Deal {{ isStatus ? 'Status' : 'Phase' }} Change</div>
  <ts-button
    class="close-button"
    type="icon"
    htmlButtonType="button"
    icon="ts_close"
    (buttonClick)="discard()"
    [tabIndex]="-1"
  ></ts-button>
</div>
<div class="flex flex-wrap px-6 pt-6 optional-view items-center relative">
  <div class="flex w-full px-3 mb-3 justify-center">
    The following fields are required in order to change the {{ isStatus ? 'status' : 'phase' }}.
  </div>
  <div class="flex flex-row w-1/2 px-6 pb-0" *ngFor="let column of displayColumns">
    <ng-container *ngIf="lookupField(column.name) as fieldDef">
      <app-form-field
        [fieldDef]="fieldDef"
        [model]="project"
        [data]="options"
        [isRequired]="enforceRequiredFields"
        class="w-full"
        (onUpdate)="onRequiredFieldUpdate($event)"
      ></app-form-field>
    </ng-container>
  </div>
  <div class="flex justify-end actions w-full px-3">
    <div class="buttons" class="flex">
      <ts-button
        variant="secondary"
        data-cy="required-fields-modal-cancel"
        class="discard-button mr-1"
        (buttonClick)="cancel()"
      >
        <span>Cancel</span>
      </ts-button>

      @if (isLoading) {
        <mat-spinner diameter="22" class="ml-2"></mat-spinner>
      } @else {
        <ts-button
          variant="primary"
          data-cy="required-fields-modal-save"
          class="send-button"
          [disabled]="isLoading || !areRequiredFieldsComplete()"
          (buttonClick)="update()"
        >
          Save
        </ts-button>
      }
    </div>
  </div>
  @if (isFieldLoading) {
    <div class="flex justify-center items-center h-full w-full absolute top-0 left-0">
      <mat-spinner diameter="42" class="ml-2"></mat-spinner>
    </div>
  }
</div>
